const createCameraQuaternion = (set) => ({
  quaternion: null,
  setCameraQuaternion: (newCameraQuanternion) =>
    set({ quaternion: newCameraQuanternion }),
});

export { createCameraQuaternion };
